import { O } from '../../../features/ui'
import { QueryOptions } from '../../../services/dynamo'
import { TableName } from '../../../tables'
import { ListResponse, useLoaders } from '../../common'
import { useSystemStateHooks } from '../../system'
import { DeliveryOrder } from '../state/types'

export const useDeliveryOrderLoaders = () => {
    const systemHooks = useSystemStateHooks()

    const loaders = useLoaders()

    return (companyId = systemHooks.companyId) => {
        const loadDeliveryOrdersBatch = async (
            options?: QueryOptions,
            optimized = true
        ) => {
            const { loadMultiple } = loaders(companyId)
            return loadMultiple(TableName.DELIVERY_ORDERS, options, optimized) as Promise<ListResponse<DeliveryOrder>>
        }

        const loadDeliveryOrder = (
            id: string,
            optimized = true
        ) => {
            const { load } = loaders(companyId)
            return load(TableName.DELIVERY_ORDERS, id, !optimized) as Promise<O<DeliveryOrder>>
        }

        const loadDeliveryOrders = (
            ids: string[],
            dbRequest = false
        ) => {
            const { loadByIds } = loaders(companyId)
            return loadByIds(TableName.DELIVERY_ORDERS, ids, dbRequest) as Promise<DeliveryOrder[]>
        }

        const loadOperationDeliveryOrders = async (
            operationId: string,
            optimized = true
        ) => {
            const { loadMultiple } = loaders(companyId)
            const options = {
                valueFilters: [{ prop: 'operationId', value: operationId }]
            }
            const response = await loadMultiple(TableName.DELIVERY_ORDERS, options, optimized)
            return response.dataTypes as DeliveryOrder[]
        }

        const countDeliveryOrders = (propName: string, propValue: string) => {
            const options = {
                valueFilters: [{
                    value: propValue,
                    prop: propName
                }],
                limit: 1
            }
            const { count2 } = loaders(companyId)
            return count2(TableName.DELIVERY_ORDERS, options)
        }

        return {
            loadDeliveryOrdersBatch,
            loadDeliveryOrder,
            loadDeliveryOrders,
            loadOperationDeliveryOrders,
            countDeliveryOrders
        }
    }
}
